import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { AppAsideModule, AppFooterModule, AppHeaderModule, AppSidebarModule } from '@coreui/angular';
import { NgbActiveModal, NgbAlertModule, NgbModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DevExtremeModule } from 'devextreme-angular';
// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CookieService } from 'ngx-cookie-service';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { AppComponent } from './app.component';
// Import routing module
import { AppRoutingModule } from './app.routing';
// Import containers
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { DefaultLayoutComponent } from './containers';
import { AccessGuard } from './guards/access.guard';
import { AccountService } from './providers/account.service';
import { AttachmentService } from './providers/attachment.service';
import { AuthService } from './providers/auth.service';
import { BaseRichService } from './providers/base-rich.service';
import { BaseService } from './providers/base.service';
import { InvoiceService } from './providers/invoice.service';
import { NetdiagService } from './providers/netdiag.service';
import { ServiceService } from './providers/service.service';
import { UserService } from './providers/user.service';
import { AdslInquiryComponent } from './views/sales/adsl-inquiry/adsl-inquiry.component';
import { AdslRoundupComponent } from './views/sales/adsl-roundup/adsl-roundup.component';
import { ItemChooserComponent } from './views/sales/item-chooser/item-chooser.component';
import { ServiceChooserComponent } from './views/sales/service-chooser/service-chooser.component';
import { TdlteOnlineComponent } from './views/sales/tdlte-online/tdlte-online.component';
import { ExpiredComponent } from './views/shared/expired/expired.component';
import { LoginComponent } from './views/shared/login/login.component';
import { PayComponent } from './views/shared/pay/pay.component';
import { PayallComponent } from './views/shared/payall/payall.component';
import { SharedModule } from './views/shared/shared.module';
import { environment } from '../environments/environment';

const config: SocketIoConfig = { url: environment.url, options: { transports: ["websocket"] } };


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        // ngx-translate and the loader module
        SocketIoModule.forRoot(config),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        AppRoutingModule,
        AppAsideModule,
        // AppBreadcrumbModule.forRoot(),
        AppFooterModule,
        AppHeaderModule,
        AppSidebarModule,
        PerfectScrollbarModule,
        BsDropdownModule.forRoot(),
        DevExtremeModule,
        FormsModule,
        NgbTypeaheadModule,
        NgbModule,
        NgbAlertModule,
        SharedModule,
        // ServiceWorkerModule.register('ngsw-worker.js', { enabled: !environment.production })
    ],
    declarations: [
        AppComponent,
        DefaultLayoutComponent,
        PayComponent,
        ExpiredComponent,
        LoginComponent,
        AdslInquiryComponent,
        ServiceChooserComponent,
        ItemChooserComponent,
        PayallComponent,
        AdslRoundupComponent,
        TdlteOnlineComponent
    ],
    providers: [{
        provide: LocationStrategy,
        useClass: HashLocationStrategy
    },
        AuthService,
        UserService,
        AccountService,
        BaseRichService,
        InvoiceService,
        NetdiagService,
        CookieService,
        BaseService,
        ServiceService,
        AttachmentService,
        AccessGuard,
        NgbActiveModal
        // UpdateService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
